<div class="notif_dot" [style.width]="size + 'px'" [style.height]="size + 'px'" [style.border-radius]="(size / 2) + 'px'"></div>